import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { DirectionIndicatorComponent } from "../../direction-indicator/direction-indicator.component";

@Component({
  selector: "er-performance-item",
  templateUrl: "./performance-item.component.html",
  standalone: true,
  imports: [CommonModule, DirectionIndicatorComponent],
})
export class PerformanceItemComponent {
  @Input() value: number = 0;
  @Input() percent: number = 0;
  @Input() comparedWith!: string;
  @Input() valueName: string = "";
  @Input() upDirectionLabel: string = "";
  @Input() downDirectionLabel: string = "";
  @Input() currency: string = "";
}
